import { t } from '../i18n/i18n'
import { handleMessage } from './stateHelper'
import { IDataContext } from '../interfaces/IDataContext'
import { EmailRequestDTO, HttpResponse, OrganisationWithUserAccountsDTO, RecipientDTO } from '../api/schemas/schema'
import { UserAccount } from '../api/schemas/schema'
import { api } from './apiHelper'

export const sendWelcomeEmail = async (dataContext: IDataContext, response: HttpResponse<OrganisationWithUserAccountsDTO, any>) => {
   const { accessToken } = dataContext.state
   if (!response.ok) {
      return
   }
   const recipientRequest: RecipientDTO = {
      recipient: response.data.userAccounts.map((userAccount: UserAccount) => ({
         email: userAccount.email,
         name: `${userAccount.firstName} ${userAccount.lastName}`,
      })),
   }
   try {
      await api(accessToken).sendWelcomeEmail(recipientRequest)

      handleMessage(
         dataContext.setRootState,
         'success',
         t('WelcomeEmailSent'),
         `${t('MailWasSentTo')} ${recipientRequest.recipient.map((x) => x.email).join(', ')}.`
      )
   } catch (error) {
      handleMessage(dataContext.setRootState, 'error', t('CouldNotSendWelcomeMail'), '')
   }
}

export const sendSubscriptionUpdateNotification = async (dataContext: IDataContext, request?: EmailRequestDTO) => {
   const { accessToken } = dataContext.state
   if (!request) {
      return
   }
   try {
      await api(accessToken).sendSubscriptionUpdateNotificationToUser(request)
      handleMessage(
         dataContext.setRootState,
         'success',
         t('UpdateSubscriptionEmailSent'),
         `${t('MailWasSentTo')} ${request.recipients.map((x) => x.email).join(', ')}.`
      )
   } catch (error) {
      handleMessage(dataContext.setRootState, 'error', t('CouldNotSendSubscriptionUpdateMail'), '')
   }
}
